var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinbase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24653_22550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C18.6273 0 24 5.37267 24 12C24 18.6273 18.6273 24 12 24C5.37267 24 0 18.6273 0 12C0 5.37267 5.37267 0 12 0Z",
    fill: "#0052FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0259 16.1872C9.69868 16.1872 7.81816 14.3015 7.81816 11.9794C7.81816 9.6573 9.70387 7.77158 12.0259 7.77158C14.1091 7.77158 15.8389 9.28846 16.1714 11.2781H20.4104C20.0519 6.956 16.4363 3.55859 12.0208 3.55859C7.3714 3.55859 3.59998 7.33002 3.59998 11.9794C3.59998 16.6287 7.3714 20.4002 12.0208 20.4002C16.4363 20.4002 20.0519 17.0027 20.4104 12.6807H16.1662C15.8337 14.6703 14.1091 16.1872 12.0259 16.1872Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24653_22550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinbase);
export default __webpack_public_path__ + "static/media/Coinbase.f9c9271ad88b23b382656f1e2b3e4ec5.svg";
export { ForwardRef as ReactComponent };